import { Component, OnInit, ViewChildren } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { CustomBlockAtributoComponent } from '../../helpers/components/customAttributeBlock/customBlockAttribute.component';
import { AlertService, GrowlType } from '../../infrastructure/services/alert.service';
import { Role } from 'app/infrastructure/model/classes/role.class';

@Component({
  selector: 'app-users-and-profiles',
  templateUrl: 'users.and.profiles.component.html'
})

export class UsersAndProfilesComponent implements OnInit {

  constructor(private aRoute: ActivatedRoute,
              private router: Router) { }

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/usersAndProfiles/users.and.profiles.component.ts